import TD from "./TD";

function TDT(props) {
  const { txt } = props;

  return (
    <TD>
      {typeof txt === "string" || typeof txt === "number" ? (
        <span className="text-lg font-medium">{txt}</span>
      ) : (
        txt
      )}
    </TD>
  );
}

export default TDT;
